export default __webpack_public_path__ + "static/media/OTHER_VOCABULARY.7bcd5476.svg";